import React from 'react';
import styled from 'styled-components';
import {proto,url} from '../../Helpers/api';
import Tabela, {TabelaLinha as TL} from '../../Common/Tabela';
import Celula from '../../Common/Celula';
import { MesExtenso } from '../../Helpers/date';
import MoreInfo from './index';

const TabelaLinha = styled(TL)`
  grid-template-columns: 240px 180px 35px 68px 68px;
`

export default function MIAfast (props) {
  const { dados={} } = props;
  const { empresa, mes, ano } = dados;
  return (
    <MoreInfo
      titulo={empresa}        
      subtitulo={`Afastamentos (${MesExtenso(mes-1)}/${ano})`}
      modalData={dados}
      f={{
        url: `${proto}://${url}/main/metricas/pessoal/afast`,
        opt: {
          method: 'POST',
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({ empresa, mes, ano })
        },
      }}
    >
    {data => data && (
      <Tabela>
        <TabelaLinha header>
          <Celula>Nome</Celula>
          <Celula>Descrição</Celula>
          <Celula>Dias</Celula>
          <Celula>Início</Celula>
          <Celula>Término</Celula>
        </TabelaLinha>
        {data.map(e => {
          return (
            <TabelaLinha>
              <Celula>{e.nome}</Celula>
              <Celula>{e.descricao}</Celula>
              <Celula>{e.qtdeDias}</Celula>
              <Celula>{e.inicio}</Celula>
              <Celula>{e.fim}</Celula>
            </TabelaLinha>
          )
        })}
      </Tabela>

    )}
    </MoreInfo>
  )
}
